<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M51.75 32c0 10.908-8.842 19.75-19.75 19.75S12.25 42.908 12.25 32 21.092 12.25 32 12.25 51.75 21.092 51.75 32zm-21.956 6.52h-3.05v-3.03H20.54v-2.572l3.59-8.818h3.381l-3.485 8.631h2.718V29.62h3.05v3.112h1.535v2.76h-1.535v3.03zM42.959 27.5l-3.75 5.225 3.69 5.525h-3.662l-1.903-2.862-1.75 2.862h-3.5l3.573-5.343L32.1 27.5h3.662l1.855 2.802 1.855-2.802h3.487z"/></svg>